import React from 'react';

import { useArchiveNotification } from './useArchiveNotification';
import Button from '../../../../../../../components/button';
import { NotificationItem } from '../../../types';
import { t } from 'i18next';

const ArchiveAction: React.FC<
  React.PropsWithChildren<{
    notification: NotificationItem;
  }>
> = ({ notification }) => {
  const [archiveNotification] = useArchiveNotification();
  return (
    <Button
      variant="link"
      label={t('notifications.buttons.archive')}
      className="py-0 pe-0"
      onClick={() => {
        archiveNotification({
          variables: {
            id: notification.id,
          },
        });
      }}
    />
  );
};
export default ArchiveAction;
